import { DateTime } from 'luxon';
import * as yup from 'yup';

export const DateTimeSchemaType = yup.mixed(
    (input): input is string | DateTime => input && DateTime.fromISO(input).isValid
);
